import {ErrorDto, FlyerDto, FlyerLanguageDto, FlyerTypeDto} from '../../dtos';

import {Action} from '../actions/flyersActions';
import {ActionType} from '../actionTypes';

export interface FlyersState {
    flyers: FlyerDto[]

    loading: boolean;
    error?: ErrorDto | null;

    type: string | null;
    archivedFlyersCount?: number;
    softDeletedFlyersCount?: number;
    flyerTypes?: FlyerTypeDto[];
    languageCultures?: FlyerLanguageDto[];
    analyticsDashboardUrl?: string;
    // accountSetting?: AccountSettingDto;
    // languageId?: number;
}

export class FlyersStateInitialState implements FlyersState {
    flyers = [];

    loading = false;
    error = null;

    type = null;
    archivedFlyersCount = 0;
    softDeletedFlyersCount = 0;
}


const initialState = new FlyersStateInitialState();

const reducer = (state: FlyersState = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.GET_FLYERS_START:
            return { ...state, flyers: initialState.flyers, error: null, loading: true, type: action.type };

        case ActionType.GET_FLYERS_SUCCESS:
            return {
                error: null,
                loading: false,
                flyers: action.payload.flyers!.map((flyer: FlyerDto, index) => {
                    return {
                        ...flyer,
                        index: index
                    }
                }),
                type: action.type,
                archivedFlyersCount: action.payload.archivedFlyersCount,
                softDeletedFlyersCount: action.payload.softDeletedFlyersCount,
                flyerTypes: action.payload.flyerTypes,
                languageCultures: action.payload.languageCultures,
                analyticsDashboardUrl: action.payload.analyticsDashboardUrl
                // accountSetting: action.payload.accountSetting,
                // languageId: action.payload.languageId
            };
        case ActionType.CHANGE_FLYERS_STATE:
            return { ... state,
                error: null,
                loading: false,
                flyers: action.payload.flyers!.map((flyer: FlyerDto, index) => {
                    return {
                        ...flyer,
                        index: index
                    }
                }),
                type: action.type
            };

        case ActionType.GET_FLYERS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.GET_FLYERS_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };

        case ActionType.SOFT_DELETE_FLYER:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.SOFT_DELETE_FLYER_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.SOFT_DELETE_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        case ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_START:
            return { ...state, error: null, loading: true, type: action.type };
        case ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        case ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.HARD_DELETE_FLYER:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.HARD_DELETE_FLYER_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };

        case ActionType.HARD_DELETE_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.ARCHIVE_FLYER:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.ARCHIVE_FLYER_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };

        case ActionType.ARCHIVE_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.SET_DEFAULT_STATE_FLYERS:
            return {
                ...state,
                error: null,
                loading: false,
                flyers: [],
                type: action.type
            };
        default:
            return state;
    }
}

export default reducer;